import {RestMethod} from '../../../_helpers/ApiConfig/RestMethod'
import FilterResponse from '../../../_helpers/FilterResponse'
import toastr from 'toastr'

export const FetchOption = {
    getByMetaType,
    getAllOption
}

/**
 * 
 * @Tapas
 * For fetching option
 */
async function getByMetaType(meta_type) {
    var reuestlink="/options";
    if(meta_type!==null && meta_type !== undefined){
     reuestlink=reuestlink+'/'+meta_type ;
    }
    
    try {
        const response=await RestMethod.GET(reuestlink);
        const api_response=FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response;
     }
     catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
         return null;
     }
}

async function getAllOption() {
    try {
        const response= await RestMethod.GET("options");
        const api_response=FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response;
     }
     catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
         return null;
     }
}



